import {ApiClient} from '@hconnect/apiclient'
import {useQuery, type UseQueryOptions} from '@tanstack/react-query'
import {type AxiosError} from 'axios'

import {TasksApiPath} from '../../../consts'

const QueryKey = 'oil-analysis-criticalities'

type UseOilAnalysisCriticalitiesOptions = Omit<
  UseQueryOptions<string[], AxiosError>,
  'queryKey' | 'queryFn'
>

export const useOilAnalysisCriticalities = (
  plantUpmId: string,
  options?: UseOilAnalysisCriticalitiesOptions
) => {
  return useQuery<string[], AxiosError>({
    queryKey: [QueryKey, plantUpmId],
    queryFn: async ({signal}) => {
      if (!plantUpmId) {
        return []
      }

      const path = `${TasksApiPath.OIL_ANALYSIS_ACTIONS}/${plantUpmId}/oil-analysis-actions/criticalities`
      const response = await ApiClient.axiosInstance.get<string[]>(path, {signal})

      return response.data ?? []
    },
    enabled: !!plantUpmId,
    ...options
  })
}
